import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import RegistrationForm from './components/RegistrationForm';
import BenefitsPanel from './components/BenefitsPanel';
import TrustSignals from './components/TrustSignals';

const Register = () => {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--color-background)' }}>
      <div className="flex-1 flex items-center justify-center px-4 py-8 md:px-6 md:py-12 lg:px-8 lg:py-16">
        <div className="w-full max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 lg:gap-12">
            <div className="w-full">
              <div className="mb-6 md:mb-8 lg:mb-10">
                <Link
                  to="/login"
                  className="inline-flex items-center gap-2 mb-6 md:mb-8 transition-smooth"
                  style={{ color: 'var(--color-primary)' }}
                >
                  <Icon name="ArrowLeft" size={20} />
                  <span className="text-sm md:text-base font-medium">Giriş Sayfasına Dön</span>
                </Link>

                <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6">
                  <div
                    className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-xl md:rounded-2xl flex items-center justify-center"
                    style={{ backgroundColor: 'var(--color-primary)' }}
                  >
                    <Icon name="Waves" size={28} color="var(--color-primary-foreground)" />
                  </div>
                  <div>
                    <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold" style={{ color: 'var(--color-primary)' }}>
                      PaddleTurkiye
                    </h1>
                    <p className="text-xs md:text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
                      Türkiye SUP Topluluğu
                    </p>
                  </div>
                </div>

                <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-2 md:mb-3" style={{ color: 'var(--color-foreground)' }}>
                  Hesap Oluştur
                </h2>
                <p className="text-sm md:text-base" style={{ color: 'var(--color-muted-foreground)' }}>
                  Türkiye'nin en büyük SUP topluluğuna katılın
                </p>
              </div>

              <div
                className="p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl shadow-organic"
                style={{
                  backgroundColor: 'var(--color-card)',
                  border: '1px solid var(--color-border)'
                }}
              >
                <RegistrationForm />

                <div className="mt-6 md:mt-8 text-center">
                  <p className="text-sm md:text-base" style={{ color: 'var(--color-muted-foreground)' }}>
                    Zaten hesabınız var mı?{' '}
                    <Link
                      to="/login"
                      className="font-semibold transition-smooth"
                      style={{ color: 'var(--color-primary)' }}
                    >
                      Giriş Yapın
                    </Link>
                  </p>
                </div>
              </div>

              <TrustSignals />
            </div>

            <div className="hidden lg:block">
              <div
                className="p-8 lg:p-10 rounded-2xl h-full shadow-organic"
                style={{
                  backgroundColor: 'var(--color-card)',
                  border: '1px solid var(--color-border)'
                }}
              >
                <BenefitsPanel />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="py-4 md:py-6 border-t" style={{ borderColor: 'var(--color-border)' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs md:text-sm text-center md:text-left" style={{ color: 'var(--color-muted-foreground)' }}>
              © {new Date()?.getFullYear()} PaddleTurkiye. Tüm hakları saklıdır.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              <Link
                to="#"
                className="text-xs md:text-sm transition-smooth"
                style={{ color: 'var(--color-muted-foreground)' }}
              >
                Kullanım Koşulları
              </Link>
              <Link
                to="#"
                className="text-xs md:text-sm transition-smooth"
                style={{ color: 'var(--color-muted-foreground)' }}
              >
                Gizlilik Politikası
              </Link>
              <Link
                to="#"
                className="text-xs md:text-sm transition-smooth"
                style={{ color: 'var(--color-muted-foreground)' }}
              >
                İletişim
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Register;